import { mapActions, mapState } from 'vuex';
import moment from 'moment';
import ImportFileIcon from '@/components/request/elements/ImportFileIcon/ImportFileIcon.vue';
import { showError } from '@/helpers/globalHelpers';
import { $EventBus } from '@/main';

export default {
	name: 'TicketComments',
	props: {
		ticket_attention: Number,
		value: Boolean,
		request: Object,
		status: String,
		userType: String,
		showSendComment: Boolean,
		userConfirmDialog: Boolean,
	},
	data() {
		return {
			types: ['EN ATENCION', 'CONSULTA', 'CONSULTA ADICIONAL', 'CONSULTA EXTERNA', 'RESUELTO'],
			selectedType: 'EN ATENCION',
			comment: null,
			loading: false,
			loadingSendMessage:false,
			showMessages: false,
			files: [],
			// mode: 'SHOW', // WRITE
			company_id: parseInt(localStorage.getItem('company_id')),
			ticketCommentfilters: {
				page: 1,
				limit: process.env.VUE_APP_PAGINATION_PER_PAGE || 20,
				pagination: false,
				description: null,
				status: null,
			},
			messagesLoaded: false,
			currentUserId: null,
			rooms: [],
			messages: [],
		};
	},

	computed: {
		...mapState('ticketComment', [
			'ticketComments',
			'loadingTicketComment',
		]),

		...mapState('auth', ['user']),

		showFooterJson() {
			const allowedStatuses = [
				'RESUELTO',
				'CONSULTA',
				'EN ATENCION',
				'PENDIENTE AP',
				'CONSULTA ADICIONAL',
				'CONSULTA EXTERNA'
			]

			return allowedStatuses.includes(this.status) && this.showSendComment && !this.loadingSendMessage;
		},

		roomsJson() { return JSON.stringify(this.rooms) },
		messagesJson() { return JSON.stringify(this.messages) },
	},

	async mounted() {
		this.currentUserId = String(this.user.id)

		this.rooms = this.formatChatRoom(this.request)

		await this.getTicketComments()
	},

	created() {
		// this.getTicketComments();
	},
	methods: {

		...mapActions('ticketComment', [
			'listTicketComments',
			'cleanTicketComments',
			'createTicketComment',
			'getFileUrl',
		]),

		async handleFetchMessages() {

			this.messagesLoaded = false;

			await this.getTicketComments();

			this.messagesLoaded = true;
		},

		formatChatRoom(request) {
			const users = []

			if (request?.responsible) {
				users.push({ _id: String(request.responsible.id), username: request.responsible.fullName || request.responsible.name })
			}

			if (request?.assigned_user) {
				const exists = users.find(u => u._id === request.assigned_user.id)
				if (!exists) {
					users.push({ _id: String(request.assigned_user.id), username: request.assigned_user.fullName || request.assigned_user.name })
				}
			}

			if (Array.isArray(request.ticket_additional_users)) {
				request.ticket_additional_users.forEach(item => {
					if (item.user_additional) {
						const exists = users.find(u => u._id === item.user_additional.id)
						if (!exists) {
							users.push({ _id: String(item.user_additional.id), username: item.user_additional.fullName || item.user_additional.name })
						}
					}
				})
			}

			return [
				{
					roomId: String(request.id),
					roomName: `Comentarios de ${request.num_ticket || 'Ticket'}`,
					users,
					lastMessage: { content: 'Bienvenidos al chat de ticket.' },
				},
			]
		},

		formatChatMessages(comments) {
			if (!Array.isArray(comments)) return []

			return comments.map(c => {
				const isSystem = c.flag_system_ticket
				const base = {
					_id: String(c.id),
					content: c.content || '',
					senderId: isSystem ? 'system' : String(c.creator_id),
					date: c.created_at ? moment(c.created_at).format('DD MMMM YYYY') : '',
					timestamp: c.created_at ? moment(c.created_at).format('HH:mm') : '',
					username: isSystem ? 'Sistema' : (c.creator?.fullName || c.creator?.name || 'Usuario'),
				}

				if (Array.isArray(c.files) && c.files.length > 0) {
					return {
						...base,
						type: 'file',
						files: c.files.map(f => ({
							name: this.getNamefile(f.comment_file),
							type: this.getMimeType(f.comment_file),
							url: f.comment_file
						}))
					}
				}

				if (isSystem) {
					return { ...base, system: true }
				}

				return base
			})
		},

		async handleSendMessage(payload) {
			try {
				this.loadingSendMessage = true;
		
				const msg = payload.detail[0];
		
				const formData = new FormData();
				formData.append('ticket_attention', this.ticket_attention);
				formData.append('type', this.selectedType);
		
				if (msg.content) {
					formData.append('content', msg.content);
				}
		
				if (msg.files && msg.files.length > 0) {
					msg.files.forEach((file, index) => {
						const extension = file.extension;
						const hasExtension = /\.[^/]+$/.test(file.name);
						const nameWithExtension = hasExtension ? file.name : `${file.name}.${extension}`;
						// Prefijo único para evitar colisiones cuando varios archivos
						// llegan con el mismo nombre (ej. imágenes pegadas del portapapeles)
						const uniqueName = `${Date.now()}-${index}-${nameWithExtension}`;
						formData.append('files', file.blob, uniqueName);
					});
				}
		
				const { ok, error } = await this.createTicketComment(formData);
		
				if (ok) {
					this.$emit('refresh');
					await this.handleFetchMessages();
				} else {
					showError(error);
				}
			} catch (error) {
				showError('Error enviando mensaje');
			} finally {
				this.loadingSendMessage = false;
			}
		},

		handleSendFile(event) {
			const fileMsg = event.detail[0]
			const uploadedUrl = fileMsg.files[0].url

			this.messages.push({
				_id: `msg-${Date.now()}`,
				content: '',
				senderId: this.currentUserId,
				timestamp: moment().format('HH:mm'),
				date: moment().format('DD MMMM YYYY'),
				files: [
					{
						name: fileMsg.files[0].name,
						type: fileMsg.files[0].type,
						url: uploadedUrl
					}
				],
				type: 'file'
			})
		},

		handleOpenFile({ detail }) {
			const { file } = detail[0];
			const fileData = file.file || file;

			if (!fileData?.url) {
				$EventBus.$emit(
					'showSnack',
					'error',
					'Archivo sin URL válida'
				);
				return
			}

			const link = document.createElement('a')
			link.href = fileData.url
			link.setAttribute('download', fileData.name || 'archivo')
			link.setAttribute('target', '_blank')
			document.body.appendChild(link)
			link.click()
			document.body.removeChild(link)
		},

		getMimeType(url) {
			const extension = url.split('.').pop().toLowerCase()
			switch (extension) {
				case 'pdf': return 'application/pdf'
				case 'png': return 'image/png'
				case 'jpg':
				case 'jpeg': return 'image/jpeg'
				case 'xlsx': return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
				default: return 'application/octet-stream'
			}
		},

		async getTicketComments() {
			try {
				this.loading = true
				const payload = {
					company_id: this.company_id,
					ticket_attention: this.ticket_attention,
				}
				const { ok, error } = await this.listTicketComments(payload)
				this.loading = false
				this.showMessages = ok

				if (ok) {
					this.messages = this.formatChatMessages(this.ticketComments)
					this.messagesLoaded = true
				} else {
					showError(error)
				}
			} catch (error) {
				console.error(error)
			}
		},

		getNamefile(url) {
			try {
				const urlParts = url.split('/');
				const fileNameWithTimestamp = urlParts[urlParts.length - 1];
				const fileNameParts = fileNameWithTimestamp.split('-');
				fileNameParts.shift();
				const fileName = fileNameParts.join('-');
				return fileName;
			} catch (error) {
				return 'EVIDENCIA';
			}
		},
	},

	beforeDestroy() {
		this.cleanTicketComments();
	},

	components: {
		ImportFileIcon,
	},
};
